<template>
  <VueGoogleAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    :id="id"
    :classname="'form-control ' + validationClass"
    :placeholder="placeholder"
    @placechanged="placeChanged"
    @inputChange="inputChange"
    :fields="['address_components', 'formatted_address', 'geometry']"
  />
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'GoogleAutocomplete',
  components: {
    VueGoogleAutocomplete
  },
  props: {
    id: String,
    placeholder: String,
    isValid: Function,
    value: {
      type: Object,
      required: true
        // state
        // postCode
        // city
        // streetAddress
        // formattedAddress
        // latitude
        // longitude
    }
  },
  data () {
    return {
      hasAddress: false,
      emptyAddressEmitted: true,
      valueChangedInternally: true
    }
  },
  mounted () {
    //console.log('GoogleAutocomplete mounted value', this.value)

    if (Object.keys(this.value).length !== 0) {
     //console.log('GoogleAutocomplete mounted hasAddress', this.addressString)
      
      this.$refs.autocomplete.update(this.addressString)

      this.hasAddress = true
      this.emptyAddressEmitted = false
      this.valueChangedInternally = false
    }
  },
  watch: {
    'value': {

    handler (newValue) {
        //console.log('GoogleAutocomplete watch value', newValue)
        if (this.valueChangedInternally) {
          this.valueChangedInternally = false
        } else {
          this.$refs.autocomplete.update(this.addressString)
        }
     },
     immediate: true,
     deep: true
    }
  },
  computed: {
    validationClass () {
     // console.log('GoogleAutocomplete validationClass')
      if (typeof this.isValid !== 'function') return ''
      const isValid = this.isValid(this.value)
      //console.log('GoogleAutocomplete validationClass isValid', isValid)
      if (isValid === null) return ''
      if (isValid === false) return 'is-invalid'
      if (isValid === true) return 'is-valid'
    },
    addressString () {
     //console.log('GoogleAutocomplete addressString', this.value.city, this.value)
      return ( this.value.formattedAddress
        // (this.value.streetAddress ? this.value.streetAddress + ', ' : '') + 
         //(this.value.city ? this.value.city + ' ' : '') +
         //(this.value.state ? this.value.state : '')
      )
    }
  },
  methods: {
    placeChanged (addressData, placeResultData, id) {
      console.debug('GoogleAutocomplete', 'placeChanged', addressData, placeResultData, id)
      this.hasAddress = true
      const streetAddress = [addressData.street_number, addressData.route].join(' ').trim()
      const address = {
        state: addressData.administrative_area_level_1,
        postCode: addressData.postal_code || '.',
        city: addressData.locality || this.localityFromAddressComponents(placeResultData.address_components),
        streetAddress: streetAddress || '.',
        formattedAddress: this.trimLast4CharactersIfNumeric(placeResultData.formatted_address), 
        latitude: addressData.latitude,
        longitude: addressData.longitude
      }
      this.$emit('input', address)
      this.valueChangedInternally = true
    },
    inputChange (newValue) {
      //console.debug('GoogleAutocomplete inputChange', newValue, this.hasAddress, this.emptyAddressEmitted)
      if (this.hasAddress) {
        this.hasAddress = false
        this.emptyAddressEmitted = false
      } else {
        if (!this.emptyAddressEmitted) {
          this.$emit('input', {})
          this.valueChangedInternally = true
          this.emptyAddressEmitted = true
        }
      }
    },
    localityFromAddressComponents (addressComponents) {
      try {
        return addressComponents.filter(item => item.types.includes('locality'))[0].long_name
      } catch (e) {
        console.error(e)
      }
    },
    trimLast4CharactersIfNumeric (str) {
      if (typeof str !== 'string') return str
      if (str.length < 5) return str
      const last4Characters = str.slice(str.length - 4, str.length)
      let isNumeric = /^\d+$/.test(last4Characters)
      if (!isNumeric) return str
      return str.slice(0, str.length - 4).trim()
    }
  }
}
</script>
